import React from 'react';

import Button from '@uikit/Form/Button/Button';
import PageHeader from '@uikit/old/PageHeader/PageHeader';

import RenderHeaderSearchAndActions from '@components/RenderHeaderSearchAndActions/RenderHeaderSearchAndActions';
import { useSelector } from 'react-redux';
import { userProfileSelector } from '@redux/selectors/userProfile.selector';
import urls from '@constants/urls';
import { redirectUserTo } from '@utils/historyHandler';
import { useHistory } from 'react-router-dom';

export default ({ searchString, changeSearchString }): JSX.Element => {
  const { info: userProfileInfo } = useSelector(userProfileSelector);
  const history = useHistory();
  const onButtonClick = () => {
    redirectUserTo(history, urls.SETTINGS_CREATE_WORKSPACE);
  };
  return (
    <PageHeader title="Workspaces">
      <div className="settings-workspace__search-and-button">
        <RenderHeaderSearchAndActions
          searchString={searchString}
          changeSearchString={changeSearchString}
        >
          {!userProfileInfo.rolesList.includes('MEMBER') && (
            <Button onClick={onButtonClick} leftIcon="plusIcon">
              <span className="settings-workspace__button-text">Create workspace</span>
            </Button>
          )}
        </RenderHeaderSearchAndActions>
      </div>
    </PageHeader>
  );
};
